import { SHORT_DATE_FORMAT } from '$constants'
import { ILoadedPayrollCalendar } from '@loadedhub/core-api-sdk'
import dayjs, { Dayjs } from 'dayjs'
import { logger, setCompanyDayStartToDate } from '$utils'
import { SelectOption } from '../types'

/**
 * The payroll calendar as the app uses it: the fields the api sends, minus the ones we
 * do not need, with the start date already a Dayjs at the company day start.
 */
export type Calendar = Required<
  Omit<ILoadedPayrollCalendar, 'periodStartDate' | 'paymentDate'>
> & {
  periodStartDate: Dayjs
}

/**
 * The generated client marks every field optional, but the api always sends them. A
 * calendar missing a field could not be shown or saved, so it is dropped instead of
 * becoming a blank option or an invalid date.
 */
export const transformCalendarOnGet = (
  calendar: ILoadedPayrollCalendar
): Calendar | null => {
  if (
    !calendar.id ||
    !calendar.name ||
    !calendar.type ||
    !calendar.periodStartDate
  ) {
    logger.error('Skipping an incomplete payroll calendar %o', calendar)
    return null
  }

  return {
    id: calendar.id,
    name: calendar.name,
    type: calendar.type,
    periodStartDate: setCompanyDayStartToDate(dayjs(calendar.periodStartDate)),
  }
}

export const getCalendarsAsOptions = (calendars: Calendar[]): SelectOption[] =>
  calendars.map((calendar) => {
    return {
      label: `${calendar.name} - Starting ${calendar.periodStartDate.format(
        SHORT_DATE_FORMAT
      )}`,
      value: calendar.id,
    }
  })
